
export enum Language {
    Czech = 1,
    Slovak = 2,
    English = 3,
}